export function frameUETQForAsc(eventType = '') {
  switch (eventType.toLowerCase()) {
    case 'asc_click_to_call':
      fireUETQForAsc({
        event_name: 'asc_click_to_call',
        event_label: 'all',
        event_category: 'Contact',
      });
      break;
    case 'asc_comm_submission':
      fireUETQForAsc({
        event_name: 'asc_comm_submission',
        event_label: 'all',
        event_category: 'Contact',
      });
      break;
    case 'asc_comm_submission_sales':
      fireUETQForAsc({
        event_name: 'asc_comm_submission_sales',
        event_label: 'sales',
        event_category: 'Contact',
      });
      break;
    case 'asc_comm_submission_sales_appt':
      fireUETQForAsc({
        event_name: 'asc_comm_submission_sales_appt',
        event_label: 'sales_appt',
        event_category: 'Contact',
      });
      break;
    case 'asc_comm_submission_service':
      fireUETQForAsc({
        event_name: 'asc_comm_submission_service',
        event_label: 'service',
        event_category: 'Contact',
      });
      break;
    case 'asc_comm_submission_service_appt':
      fireUETQForAsc({
        event_name: 'asc_comm_submission_service_appt',
        event_label: 'service_appt',
        event_category: 'Contact',
      });
      break;
    case 'asc_form_submission':
      fireUETQForAsc({
        event_name: 'asc_form_submission',
        event_label: 'all',
        event_category: 'SubmitLeadForm',
      });
      break;
    case 'asc_form_submission_parts':
      fireUETQForAsc({
        event_name: 'asc_form_submission_parts',
        event_label: 'parts',
        event_category: 'SubmitLeadForm',
      });
      break;
    case 'asc_form_submission_sales':
      fireUETQForAsc({
        event_name: 'asc_form_submission_sales',
        event_label: 'sales',
        event_category: 'SubmitLeadForm',
      });
      break;
    case 'asc_form_submission_sales_appt':
      fireUETQForAsc({
        event_name: 'asc_form_submission_sales_appt',
        event_label: 'sales_appt',
        event_category: 'SubmitLeadForm',
      });
      break;
    case 'asc_form_submission_service':
      fireUETQForAsc({
        event_name: 'asc_form_submission_service',
        event_label: 'service',
        event_category: 'SubmitLeadForm',
      });
      break;
    case 'asc_form_submission_service_appt':
      fireUETQForAsc({
        event_name: 'asc_form_submission_service_appt',
        event_label: 'service_appt',
        event_category: 'SubmitLeadForm',
      });
      break;
    case 'asc_item_pageview':
      fireUETQForAsc({
        event_name: 'asc_item_pageview',
        event_label: 'all',
        event_category: 'PageView',
      });
      break;

    default:
      break;
  }
}

export function fireUETQForAsc(data = {}) {
  try {
    if (window.uetq) {
      window.uetq.push('event', data.event_name, {
        event_label: data.event_label,
        event_category: data.event_category,
      });
      console.log('pushig event');
    }
  } catch (error) {
    console.log('Error With uetq Function');
    console.log(error);
  }
}
